import { loadRemoteModule } from '@angular-architects/module-federation';
import { Component, OnInit, ComponentFactoryResolver, ViewContainerRef, ComponentRef, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoggerService } from '@app/logger/logger.service';
import { environment } from '@env/environment';

const log = new LoggerService('MICROFRONTEND HOST COMPONENT');

@Component({
  selector: 'microfrontend-host',
  templateUrl: './microfrontend-host.component.html',
  styleUrls: ['./microfrontend-host.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class MicrofrontendHostComponent implements OnInit {

  private routerData;

  constructor(
    private activatedRoute: ActivatedRoute,
    private viewContainerRef: ViewContainerRef,
    private componentFactoryRersolver: ComponentFactoryResolver
  ) { }


  async ngOnInit() {
    // log.info('Iniciando componente...');
    this.activatedRoute.data.subscribe(data => this.routerData = data);

    // log.info('Router data: ', this.routerData);
    // log.info('remoteEntry: ', environment[this.routerData.remoteEntry]);
    // log.info('Exposed module:', this.routerData.exposedModule);
    // log.info('Remote name:', this.routerData.exposedModule.replace('./', ''));
    // log.info('Component: ', this.routerData.componentName);


    const module = await loadRemoteModule({
      remoteEntry: environment[this.routerData.remoteEntry],
      exposedModule: this.routerData.exposedModule,
      type: "module",
    });

    const factory = this.componentFactoryRersolver.resolveComponentFactory(module[this.routerData.componentName]);

    const componentRef: ComponentRef<{ test: string }> = this.viewContainerRef.createComponent(factory.componentType);


  }
}